// @flow
import React, {useCallback, useState} from 'react';
import {useUserData} from "../../../hooks/user/useUserData";
import {useTranslation} from "react-i18next";
import {CUSTOMER_INFO} from "../../../locales/components/namespaces";
import useUserAction from "../../../hooks/user/useUserAction";
import Title from "../../title/title";
import Divider from "../../divider/divider";
import moment from "moment";
import {PAGE_REPORTS} from "../../../locales/pages/namespaces";
import SelectStore from "../../selectStore/selectStore";
import Util from "../../util/util";
import Table from "../../table/table";
import './report3.css'
import {withPermissionHOC} from "../../../modules/permission/components/permissionHOC/permissionHOC";
import {Permissions} from "../../../helpers/constants";
import PeriodSelect from "../../periodSelect/periodSelect";
import DropdownFilter from "../../table/partials/filters/dropdownFilter/dropdownFilter";
import NumberRangeFilter from "../../table/partials/filters/numberRangeFilter/numberRangeFilter";
import TextFilter from "../../table/partials/filters/textFilter/textFilter";
import {useHasPermission} from "../../../modules/permission/hooks/useHasPermission";

const defaultDate1 = moment().endOf('quarter').toDate()
const defaultDate2 = moment().startOf('quarter').toDate()
const defaultDate3 = moment().subtract(1, 'quarter').endOf('quarter').toDate()
const defaultDate4 = moment().subtract(1, 'quarter').startOf('quarter').toDate()

const NumberCell = ({value}) => (
    <div style={{textAlign: "right"}}>
        {Number(value).toFixed(2)}
    </div>
)

const Report3 = () => {
    const [selectedStore, setSelectedStore] = useState('all');
    const isAdmin = useHasPermission([Permissions.AccessAdmin], {shouldView: true})
    const isSalesPerson = useHasPermission([Permissions.AccessSalesPerson], {shouldView: true})
    const {t} = useTranslation([CUSTOMER_INFO, PAGE_REPORTS])
    const [ranges, setRanges] = useState({
        range1: [defaultDate4, defaultDate3],
        range2: [defaultDate2, defaultDate1],
    })
    const {report3IndexTable} = useUserData()
    const {getReport3Info} = useUserAction()
    const onSubmit = (values) => {
        const {range1, range2} = values
        setRanges({range1, range2})
    }
    const dataManager = useCallback((pageIndex, pageSize) => {
        getReport3Info(pageIndex, pageSize, ranges, selectedStore)
    }, [getReport3Info, ranges, selectedStore])
    return (
        <div className={'report3-page contained-page bg-container'}>
            <Util>
                <Title variant={"h3"}>
                    {t(PAGE_REPORTS + ':COMPARATIVE DATA BETWEEN 2 PERIODS')}
                </Title>
                {!isAdmin && !isSalesPerson && <SelectStore
                    showAllOption
                    updateAcrossApplication={false}
                    selected={selectedStore === 'all' ? selectedStore : selectedStore.id}
                    onSelection={setSelectedStore}
                />}
            </Util>
            <Divider/>
            <PeriodSelect
                initialRange1={ranges.range1}
                initialRange2={ranges.range2}
                onSubmit={onSubmit}
            />
            <br/>
            <div className="table-wrapper">
                <Table
                    data={report3IndexTable}
                    pageSize={10}
                    dataManager={dataManager}
                    // noHeader
                    noPagination
                    customStyle
                    noMeta
                    groupBy={['category.title', 'subcategory.title']}
                    expanded={report3IndexTable
                        .items
                        .reduce((p, n) => ({
                            ...p,
                            ['category.title:' + n.category.title]: true
                        }), {})
                    }
                    columns={[
                        {
                            Header: t('Category'),
                            accessor: 'category.title',
                            Filter: DropdownFilter,
                            filter: 'includes',
                        },
                        {
                            Header: t('Sub Category'),
                            accessor: 'subCategory.title',
                            Filter: DropdownFilter,
                            filter: 'includes',
                        },
                        {
                            Header: t('Item'),
                            accessor: 'description',
                            Filter: TextFilter,
                            filter: 'includes',
                        },
                        {
                            Header: t('period_1'),
                            columns: [
                                {
                                    Header: t('Quantity'),
                                    accessor: 'period1.quantity',
                                    aggregate: 'sum',
                                    Filter: NumberRangeFilter,
                                    filter: 'between',
                                    Cell: NumberCell,
                                },
                                {
                                    Header: t('Price'),
                                    accessor: 'period1.price',
                                    aggregate: 'sum',
                                    Filter: NumberRangeFilter,
                                    filter: 'between',
                                    Cell: NumberCell,
                                },
                            ]
                        },
                        {
                            Header: t('period_2'),
                            columns: [
                                {
                                    Header: t('Quantity'),
                                    accessor: 'period2.quantity',
                                    aggregate: 'sum',
                                    Filter: NumberRangeFilter,
                                    filter: 'between',
                                    Cell: NumberCell,
                                },
                                {
                                    Header: t('Price'),
                                    accessor: 'period2.price',
                                    aggregate: 'sum',
                                    Filter: NumberRangeFilter,
                                    filter: 'between',
                                    Cell: NumberCell,
                                },
                            ]
                        }
                    ]}
                />
            </div>
        </div>
    )
}

export default withPermissionHOC(Report3, [Permissions.AccessReports])